import {useQuery} from "@tanstack/react-query";
import {readCompanyInfo} from "../../../../api/manage/company/CompanyApi";
import {CompanyInfoType} from "../interface";
import {companyInfoInit} from "../state";

interface Props {
    param: { id: number },
    enabled: boolean
}

export const useReadCompanyInfo = ({param, enabled}: Props): { data: CompanyInfoType } => {
    const {data} = useQuery({
        queryKey: ["readCompanyInfo", param],
        queryFn: async () => await readCompanyInfo(param),
        select: (res) => res?.data.result ?? companyInfoInit,
        enabled: enabled
    });

    return {data};
};
